"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportStatus = exports.ImportFormat = exports.NotificationStatus = exports.NotificationChannel = exports.InvitationStatus = exports.MessageStatus = exports.ChatType = exports.FactStatus = exports.PersonFactType = exports.RelationshipType = exports.Visibility = exports.Gender = exports.UserStatus = exports.MembershipStatus = exports.FamilyRole = exports.RESERVED_USERNAMES = exports.USERNAME_PATTERN = exports.USERNAME_MAX_LENGTH = exports.USERNAME_MIN_LENGTH = void 0;
exports.normalizeUsername = normalizeUsername;
exports.isValidUsername = isValidUsername;
exports.roleRank = roleRank;
exports.hasAtLeastRole = hasAtLeastRole;
exports.USERNAME_MIN_LENGTH = 3;
exports.USERNAME_MAX_LENGTH = 32;
exports.USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{1,30}[a-z0-9]$/;
exports.RESERVED_USERNAMES = new Set([
    'admin',
    'administrator',
    'api',
    'family',
    'help',
    'heritage',
    'info',
    'login',
    'mail',
    'owner',
    'register',
    'root',
    'support',
    'system',
]);
function normalizeUsername(value) {
    return value.trim().toLowerCase();
}
function isValidUsername(value) {
    const normalized = normalizeUsername(value);
    return (normalized.length >= exports.USERNAME_MIN_LENGTH &&
        normalized.length <= exports.USERNAME_MAX_LENGTH &&
        exports.USERNAME_PATTERN.test(normalized) &&
        !exports.RESERVED_USERNAMES.has(normalized));
}
var FamilyRole;
(function (FamilyRole) {
    FamilyRole["OWNER"] = "OWNER";
    FamilyRole["ADMIN"] = "ADMIN";
    FamilyRole["EDITOR"] = "EDITOR";
    FamilyRole["MEMBER"] = "MEMBER";
    FamilyRole["VIEWER"] = "VIEWER";
})(FamilyRole || (exports.FamilyRole = FamilyRole = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["ACTIVE"] = "ACTIVE";
    MembershipStatus["SUSPENDED"] = "SUSPENDED";
})(MembershipStatus || (exports.MembershipStatus = MembershipStatus = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["DISABLED"] = "DISABLED";
    UserStatus["PENDING"] = "PENDING";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["OTHER"] = "OTHER";
    Gender["UNKNOWN"] = "UNKNOWN";
})(Gender || (exports.Gender = Gender = {}));
var Visibility;
(function (Visibility) {
    Visibility["FAMILY"] = "FAMILY";
    Visibility["PRIVATE"] = "PRIVATE";
    Visibility["RESTRICTED"] = "RESTRICTED";
    Visibility["PUBLIC"] = "PUBLIC";
})(Visibility || (exports.Visibility = Visibility = {}));
var RelationshipType;
(function (RelationshipType) {
    RelationshipType["PARENT_CHILD"] = "PARENT_CHILD";
    RelationshipType["SPOUSE"] = "SPOUSE";
    RelationshipType["PARTNER"] = "PARTNER";
    RelationshipType["SIBLING"] = "SIBLING";
})(RelationshipType || (exports.RelationshipType = RelationshipType = {}));
var PersonFactType;
(function (PersonFactType) {
    PersonFactType["BIRTH"] = "BIRTH";
    PersonFactType["DEATH"] = "DEATH";
    PersonFactType["MARRIAGE"] = "MARRIAGE";
    PersonFactType["DIVORCE"] = "DIVORCE";
    PersonFactType["OCCUPATION"] = "OCCUPATION";
    PersonFactType["WORK"] = "WORK";
    PersonFactType["RESIDENCE"] = "RESIDENCE";
    PersonFactType["EDUCATION"] = "EDUCATION";
    PersonFactType["BURIAL"] = "BURIAL";
    PersonFactType["TRIP"] = "TRIP";
    PersonFactType["MEETING"] = "MEETING";
    PersonFactType["MEMORY"] = "MEMORY";
    PersonFactType["OTHER"] = "OTHER";
})(PersonFactType || (exports.PersonFactType = PersonFactType = {}));
var FactStatus;
(function (FactStatus) {
    FactStatus["CLAIM"] = "CLAIM";
    FactStatus["CONFIRMED"] = "CONFIRMED";
    FactStatus["REJECTED"] = "REJECTED";
})(FactStatus || (exports.FactStatus = FactStatus = {}));
var ChatType;
(function (ChatType) {
    ChatType["DIRECT"] = "DIRECT";
    ChatType["GROUP"] = "GROUP";
})(ChatType || (exports.ChatType = ChatType = {}));
var MessageStatus;
(function (MessageStatus) {
    MessageStatus["SENT"] = "SENT";
    MessageStatus["DELIVERED"] = "DELIVERED";
    MessageStatus["READ"] = "READ";
})(MessageStatus || (exports.MessageStatus = MessageStatus = {}));
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["EXPIRED"] = "EXPIRED";
    InvitationStatus["REVOKED"] = "REVOKED";
})(InvitationStatus || (exports.InvitationStatus = InvitationStatus = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["IN_APP"] = "IN_APP";
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["PUSH"] = "PUSH";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["PENDING"] = "PENDING";
    NotificationStatus["SENT"] = "SENT";
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["READ"] = "READ";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
var ImportFormat;
(function (ImportFormat) {
    ImportFormat["GEDCOM"] = "GEDCOM";
    ImportFormat["JSON"] = "JSON";
    ImportFormat["CSV"] = "CSV";
})(ImportFormat || (exports.ImportFormat = ImportFormat = {}));
var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PENDING"] = "PENDING";
    ImportStatus["RUNNING"] = "RUNNING";
    ImportStatus["DONE"] = "DONE";
    ImportStatus["FAILED"] = "FAILED";
})(ImportStatus || (exports.ImportStatus = ImportStatus = {}));
function roleRank(role) {
    const order = [
        FamilyRole.VIEWER,
        FamilyRole.MEMBER,
        FamilyRole.EDITOR,
        FamilyRole.ADMIN,
        FamilyRole.OWNER,
    ];
    return order.indexOf(role);
}
function hasAtLeastRole(role, min) {
    return roleRank(role) >= roleRank(min);
}
__exportStar(require("./location"), exports);
__exportStar(require("./partial-date"), exports);
//# sourceMappingURL=index.js.map